import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
const validateFunction = ({ path, pathName }) => {
  if (pathName === ":insightType") {
    // allow numbers as child routes since they are used for custom datasets
    return _.isNaN(path)
      ? _.includes(["skills", "globalContexts", "lpas"], path)
      : true;
  }
};
export default store => ({
  path: "overallProgrammeInsights/:insightType",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "planning-insights" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return withDynamicUrlValidation({
          component,
          urlValidationType: "customValidation",
          customUrlValidationFunction: validateFunction,
        });
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
